export default __webpack_public_path__ + "static/media/loading.b19295f9.mp4";